export const VALID_ADDRESS_STATUS_TYPES = [
    "ChooseRestaurant",
    "ChangeRestaurant",
    "RestaurantDoesntDeliverTo",
    "RestaurantDelivers",
];
